export default {
    //API_ENDPOINT: 'http://localhost:8000/api',
    API_ENDPOINT: 'https://thawing-basin-06464.herokuapp.com/api',
    API_KEY: process.env.REACT_APP_API_KEY,
    TOKEN_KEY: 'brain-client-auth-token',

}